import React from 'react';
import { Box, Typography, Button, Popover } from '@mui/material';
import { colors } from '../../themes/typography';

/**
 * Minimal confirmation popover for delete actions
 * Follows the same pattern as DateEditPopover
 */
const DeleteConfirmationPopover = ({
  open,
  anchorEl,
  onClose,
  onConfirm,
  loading = false,
  message = "Delete this experiment?",
  confirmText = "Delete",
  cancelText = "Cancel"
}) => {
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      PaperProps={{
        sx: {
          borderRadius: '8px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
          border: `1px solid ${colors.border.light}`,
          p: 2,
          minWidth: '200px'
        }
      }}
    >
      <Box>
        <Typography sx={{
          fontSize: '12px',
          color: colors.text.primary,
          fontWeight: 500,
          mb: 2
        }}>
          {message}
        </Typography>
        
        <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
          <Button
            size="small"
            onClick={onClose}
            disabled={loading}
            sx={{
              fontSize: '11px',
              textTransform: 'none',
              color: colors.text.secondary
            }}
          >
            {cancelText}
          </Button>
          <Button
            size="small"
            onClick={onConfirm}
            disabled={loading}
            sx={{
              fontSize: '11px',
              textTransform: 'none',
              backgroundColor: colors.critical.text,
              color: 'white',
              '&:hover': {
                backgroundColor: '#dc2626'
              }
            }}
          >
            {loading ? 'Deleting...' : confirmText}
          </Button>
        </Box>
      </Box>
    </Popover>
  );
};

export default DeleteConfirmationPopover;